import { ExploreActionTypes, ExploreState, ChatMessage } from './exploreTypes';

const INIT_STATE: ExploreState = {
  sessionId: null,
  messages: [],
  topInsights: [],
  isReadyToSummarise: false,
  proposedInsight: null,
  isLoading: false,
  isSummarising: false,
  error: null,
};

const exploreReducer = (state = INIT_STATE, action: any): ExploreState => {
  switch (action.type) {

    case ExploreActionTypes.SEND_MESSAGE:
      return { ...state, isLoading: true, error: null };

    case ExploreActionTypes.SUMMARISE:
      return { ...state, isSummarising: true, error: null };

    case ExploreActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case ExploreActionTypes.SEND_MESSAGE: {
          const { sessionId, reply, insights = [], userMessage } = action.payload.data;
          const newMessages: ChatMessage[] = [
            ...state.messages,
            { role: 'user', content: userMessage, timestamp: new Date().toISOString() },
            { role: 'assistant', content: reply, timestamp: new Date().toISOString() },
          ];
          return {
            ...state,
            sessionId:    sessionId ?? state.sessionId,
            messages:     newMessages,
            topInsights:  insights.length > 0 ? insights : state.topInsights,
            isLoading:    false,
            error:        null,
          };
        }
        case ExploreActionTypes.SUMMARISE:
          return {
            ...state,
            proposedInsight: action.payload.data,
            isSummarising:   false,
            error:           null,
          };
        default:
          return state;
      }

    case ExploreActionTypes.API_RESPONSE_ERROR:
      return { ...state, isLoading: false, isSummarising: false, error: action.payload.error };

    case ExploreActionTypes.RESET:
      return INIT_STATE;

    default:
      return state;
  }
};

export default exploreReducer;
